import {lazy} from "react";

export const HistoryListSingleVoyagesLazy = lazy(() => import('./HistoryListSingleVoyages'))